export default __webpack_public_path__ + "5b5e615cfefa9da8d343f37a605ca4ff.png";